import { useMyPermissions } from "modules/my-permissions";
import React, { CSSProperties, FormEvent, useState } from "react";
import { api } from "shared/api";
import { useApiMethod } from "shared/lib";
import { Button, Fieldset, Input } from "shared/ui";

export interface ICompanyNameForm {
  companySlug: string;

  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const CompanyNameForm = (props: ICompanyNameForm) => {
  const permissions = useMyPermissions(props.companySlug);

  const company = api.company.useCompanyGet(props.companySlug);
  const submit = useApiMethod(api.company.companyChangeName);

  const [value, setValue] = useState<string>();

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();

    if (!company.data || !value) return;
    await submit.call(company.data.id, { value });
    await company.mutate();
    setValue(undefined);
  };

  return (
    <form className={props.className} style={props.style} id={props.htmlId} onSubmit={onSubmit}>
      <Fieldset disabled={!permissions?.company.general.update}>
        <Fieldset.Content>
          <Fieldset.Title>Название компании</Fieldset.Title>
          <Fieldset.Subtitle>
            Название вашей компании или филиала, которое вы и добавленные сотрудники будете видеть в списке компаний.
            Рекомендуем использовать брендовое, а не юридическое название.
          </Fieldset.Subtitle>
          <Input
            tabIndex={-1}
            style={{ maxWidth: 300 }}
            name="organization"
            value={value ?? company.data?.name}
            onChange={(e) => setValue(e.target.value)}
          />
        </Fieldset.Content>
        <Fieldset.Footer>
          <Fieldset.Footer.Status>
            {!submit.error && <>Максимум 32 символа</>}
            {submit.error && <Fieldset.Error>{submit.error.message}</Fieldset.Error>}
          </Fieldset.Footer.Status>
          <Fieldset.Footer.Actions>
            <Button htmlType="submit" size="small" disabled={!value} loading={submit.loading} tabIndex={-1}>
              Сохранить
            </Button>
          </Fieldset.Footer.Actions>
        </Fieldset.Footer>
      </Fieldset>
    </form>
  );
};

CompanyNameForm.defaultProps = {};
